import _ from 'lodash'
export default {
  // 给table 加列
  columnsCalculate(name, columns, widthArray) {
    if (columns !== null && columns !== undefined) {
      columns.forEach((element, index) => {
        if (!element.fixed) {
          element.width = widthArray[index]
        }
        element.key = element.dataIndex
      })
    }
    return columns
  },

  //过滤字符串
  arr_filter(arr_string) {
    let new_arr = ''
    if (arr_string) {
      let arr_node = arr_string.split('】,【')
      new_arr = arr_node.map(element => {
        let str = element.replace('【', '').replace('】', '')
        return str
      })
    }
    return new_arr
  },

  // 整型计算大小
  toNumFormatter(num, digit) {
    if (num) {
      if (isNaN(num)) {
        return
      }
      num = typeof num == 'string' ? parseFloat(num) : num //判断是否是字符串如果是字符串转成数字
      num = num.toFixed(digit) //保留两位
      num = parseFloat(num) //转成数字
      num = num.toLocaleString() //转成金额显示模式
      return num
    } else {
      return (num = 0)
    }
  },

  // 合并对象
  assign: (object1, object2) => {
    return _.assign({}, object1, object2)
  },

  plus(a, b) {
    var c, d, e
    try {
      c = a.toString().split('.')[1].length
    } catch (f) {
      c = 0
    }
    try {
      d = b.toString().split('.')[1].length
    } catch (f) {
      d = 0
    }
    return (e = Math.pow(10, Math.max(c, d))), (this.mul(a, e) + this.mul(b, e)) / e
  },

  mul(a, b) {
    var c = 0,
      d = a.toString(),
      e = b.toString()
    try {
      c += d.split('.')[1].length
    } catch (f) { }
    try {
      c += e.split('.')[1].length
    } catch (f) { }
    return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c)
  },
}



// WEBPACK FOOTER //
// ./src/utils/utils_width.js